import { Box, Callout } from "@radix-ui/themes"
import { InfoCircledIcon } from "@radix-ui/react-icons"

export enum TipType {
  INFO = "info",
  WARNING = "warning",
}
type TipProps = {
  content: String | JSX.Element
  type: TipType
}
export const Tip = ({ content: text, type }: TipProps) => {
  return (
    <Box p="3">
      <Callout.Root
        size="2"
        variant="surface"
        color={type === TipType.INFO ? "blue" : "yellow"}
        style={{ alignItems: "center" }}
        highContrast
      >
        <Callout.Icon>
          <InfoCircledIcon width={24} height={24} />
        </Callout.Icon>
        <Callout.Text>{text}</Callout.Text>
      </Callout.Root>
    </Box>
  )
}
